import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { setOnlyDirectFlights } from '../../redux/currentSearch/actions';
import { Checkbox } from '../../components';
import { withPageContext } from '../../utils/PageContext/PageContext';
import { ABUtils } from '../../utils';

const DirectFlightSelector = ({ setOnlyDirectFlights, value, trackEvent, isRailsSearcher }) => {
    const { t } = useTranslation();
    const { isAbTrain } = ABUtils.getABs();
    const onDirectFlightChange = () => {
        setOnlyDirectFlights(!value);

        trackEvent({
            action: 'searcher_flights',
            label: value ? 'direct_unchecked' : 'direct_checked',
        });
    };

    const checkboxProps = {
        id: 'direct-flight-switcher',
        checked: value,
        onChange: onDirectFlightChange,
    };
    const keyId = isAbTrain || isRailsSearcher ? 'moreOptions.directflight.title.TRAINS' : 'moreOptions.directflight.title.main';
    return (
        <Checkbox {...checkboxProps}>
            {t(keyId)}
        </Checkbox>
    );
};

DirectFlightSelector.propTypes = {
    setOnlyDirectFlights: PropTypes.func.isRequired,
    value: PropTypes.bool,
    trackEvent: PropTypes.func.isRequired,
};

DirectFlightSelector.defaultProps = {
    value: false,
};

const DirectFlightSelectorWithPageContext = withPageContext(
    DirectFlightSelector,
);
export { DirectFlightSelectorWithPageContext as DirectFlightSelector };

const mapStateToProps = ({ currentSearch }) => ({
    value: currentSearch.isDirect,
});

const ConnectedDirectFlightSelector = connect(mapStateToProps, {
    setOnlyDirectFlights,
})(DirectFlightSelectorWithPageContext);

export { ConnectedDirectFlightSelector };
